import React, { useEffect, useState } from 'react'
import MembershipDetailPanel from 'src/components/MenuBar/panels/MembershipDetailPanel/MembershipDetailPanel'
import HeaderBar from 'src/components/HeaderBar/HeaderBar'
import styles from './membership.scss'
import { userSelector, topBannerSelector } from 'src/selectors'
import { useSelector } from 'react-redux'
import { getPlanTypeBySlug, PlanType } from 'src/services/stripe_checkout_configs'
import DownloadAppBanner from 'components/global/DownloadAppBanner'
import cn from 'classnames'

const PlanThemMapping = {
  [PlanType.Free]: 'free',
  [PlanType.Essentials]: 'essential',
  [PlanType.Premium]: 'premium',
  [PlanType.Basic]: 'basic',
  [PlanType.InvitationMaker]: 'invitation-maker',
  [PlanType.partyHost]: 'party-host'
}
const planThemeColor = {
  premium: styles['premium-main'],
  essential: styles['party-host-main'],
  basic: styles['invitation-maker-main'],
  free: '#f9f9f9',
  'invitation-maker': styles['invitation-maker-main'],
  'party-host': styles['party-host-main']
}

const Membership = () => {
  const [theme, setTheme] = useState('free')
  const user = useSelector(userSelector) || {}
  const { visible: isBannerVisible } = useSelector(topBannerSelector)
  const currentSub = user.current_subscription

  useEffect(() => {
    let theme = 'free'

    if (currentSub) {
      theme = PlanThemMapping[getPlanTypeBySlug(currentSub.plan.slug)] || 'free'
      setTheme(theme)
    }

    const metaTag = document.createElement('meta')
    metaTag.setAttribute('name', 'theme-color')
    metaTag.setAttribute('content', planThemeColor[theme])

    document.head.appendChild(metaTag)

    return () => {
      document.head.removeChild(metaTag)
    }
  }, [currentSub])

  useEffect(() => {
    const planType = getPlanTypeBySlug(currentSub?.plan?.slug)
    const isFreePlan = planType === PlanType.Free

    if (isFreePlan) {
      window.location.reload()
    }
  }, [currentSub])

  return (
    <div className={cn(styles['membership-container'], styles[theme])}>
      <HeaderBar
        menuIcon
        whiteIcon={theme !== 'free'}
        containerClassName={cn(styles['header-bar-inner'])}
      >
        <div className={styles['title']}>Membership</div>
      </HeaderBar>
      {isBannerVisible && <DownloadAppBanner containerClassName={styles['banner-container']} />}
      <div className={cn(styles['panel-container'])}>
        <div
          className={cn(
            styles['membership-panel'],
            !isBannerVisible && styles['membership-panel-radius']
          )}
        >
          <MembershipDetailPanel />
        </div>
      </div>
    </div>
  )
}

export default Membership
